<template>
  <div>
    <v-layout wrap>
      <v-flex>
        <section>
          <v-card
            flat>
            <v-tabs
              v-model="selected.menu"
              background-color="transparent"
              color="#ff64ad"
              slider-size="5"
              show-arrows
              next-icon="mdi-arrow-right-bold-box-outline"
              prev-icon="mdi-arrow-left-bold-box-outline"
              dense
              grow
              class="d-flex justify-start tabs-stream">
              <v-tab
                v-for="(item, index) in menu"
                :key="index"
                class="px-0 mr-4 d-flex align-center">
                <v-avatar
                  tile
                  size="20">
                  <v-img 
                    contain
                    :src="item.icon">
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center">
                        <v-progress-circular 
                          indeterminate 
                          size="20"
                          color="#ff64ad">
                        </v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-avatar>

                <span 
                  class="body-2 text-capitalize ml-2" 
                  :class="selected.menu === index ? 'font-weight-bold' : 'text-third'">
                  {{ item.title }}
                </span>
              </v-tab>
            </v-tabs>

            <div>
              <Banner v-if="selected.menu === 0"
                :detail="menu[selected.menu]" />

              <Aboutus v-if="selected.menu === 1"
                :detail="menu[selected.menu]" />

              <Contactus v-if="selected.menu === 2"
                :detail="menu[selected.menu]" />

              <Privacy v-if="selected.menu === 3"
                :detail="menu[selected.menu]" />

              <Faq v-if="selected.menu === 4"
                :detail="menu[selected.menu]" />
            </div>
          </v-card>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        selected: {
          menu: 0
        },
        menu: [
          {
            title: 'Banner',
            icon: require('@/assets/image/banner.png')
          },
          {
            title: 'Tentang Kami',
            icon: require('@/assets/image/about_us.png')
          },
          {
            title: 'Kontak Kami',
            icon: require('@/assets/image/contact_us.png')
          },
          {
            title: 'Kebijakan Privasi',
            icon: require('@/assets/image/privacy_policy.png')
          },
          {
            title: 'FAQ',
            icon: require('@/assets/image/faq.png')
          }
        ]
      }
    },
    components: {
      Banner: () => import(/* webpackPrefetch: true */ '@/components/setting/banner.vue'),
      Aboutus: () => import(/* webpackPrefetch: true */ '@/components/setting/aboutus.vue'),
      Contactus: () => import(/* webpackPrefetch: true */ '@/components/setting/contactus.vue'),
      Privacy: () => import(/* webpackPrefetch: true */ '@/components/setting/privacy.vue'),
      Faq: () => import(/* webpackPrefetch: true */ '@/components/setting/faq.vue'),
    },
    computed: {
      
    },
    watch: {
      
    },
    mounted () {
      
    },
    methods: {
      
    }
  }
</script>